import { useQuery } from 'react-query';
import { buildEndpoint } from '../endpoints';
import { apifetch } from '../robotapi';

export interface ForecastRetirementRequest {
    riskProfileId?: number;
    paymentSingleAmount?: number;
    paymentRecurringAmount?: number;
    paymentRecurringInterval?: 'Month' | 'Year';
    investmentEndDate?: string;
    automaticRiskReduction?: boolean;
    retirementPeriodInYears?: number;
    monthOfPayment?: number;
}

export interface ForecastRetirement {
    monthlyRetirementValues?: ForecastRetirementValue;
    valuesOnInvestmentEndDate?: ForecastValue;
    monthlyForecastValues?: ForecastRetirementMonthlyValues;
}

interface ForecastRetirementMonthlyValues {
    pessimistic?: Array<number>;
    median?: Array<number>;
    optimistic?: Array<number>;
}

interface ForecastValue {
    date?: Date;
    pessimistic?: number;
    median?: number;
    optimistic?: number;
}

interface ForecastRetirementValue {
    pessimistic?: number;
    median?: number;
    optimistic?: number;
}



const getForecastRetirementUrl = buildEndpoint(['forecast','retirement']);

const getForecastRetirementApiCall = (body: ForecastRetirementRequest) =>
    apifetch<ForecastRetirement, ForecastRetirementRequest>(getForecastRetirementUrl, 'POST')(body);

export const useGetForecastRetirement = (body: ForecastRetirementRequest, enabled: boolean = true) => {
    const query = useQuery<ForecastRetirement>(['forecastretirement', body], async () => {
        return getForecastRetirementApiCall(body);
    },
    {
        enabled: enabled,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
    }
    );

    return query;
};


